import { restoreCollapsedPython } from "./formatPythonCode";

export const detectCodeLanguage = (text) => {
  const value = String(text || "").trim();

  if (!value) return null;

  if (
    /^<!doctype\s+html/i.test(value) ||
    /^<(?:html|head|body|div|span|button|script|style|p|h[1-6])\b/i.test(value)
  ) {
    return "html";
  }

  if (
    /^[\t ]*(?:(?:async[\t ]+)?def[\t ]+\w+[\t ]*\(|class[\t ]+\w+[\t ]*(?:\([^\n]*\)[\t ]*)?:)/m.test(
      value,
    )
  ) {
    return "python";
  }

  if (/^(?:const|let|var|function)\s+[\w$]+|^document\.|=>/m.test(value)) {
    return "javascript";
  }

  if (/^[\t ]*(?:from\s+\S+\s+import\s+|import\s+\S+)/m.test(value)) {
    return "python";
  }

  if (/^(?:SELECT|INSERT|UPDATE|DELETE|CREATE)\s+/i.test(value)) {
    return "sql";
  }

  if (/^(?:\{|\[)/.test(value)) {
    try {
      JSON.parse(value);
      return "json";
    } catch {
      return null;
    }
  }

  return null;
};

export const formatChatCode = (text, language = detectCodeLanguage(text)) => {
  const value = String(text || "");
  return language === "python" || language === "py"
    ? restoreCollapsedPython(value)
    : value;
};

export const normalizeMessageContent = (text) => {
  const value = String(text || "");
  return detectCodeLanguage(value) || value.includes("```")
    ? formatChatCode(value)
    : value.trim();
};
